// extracted by mini-css-extract-plugin
export default {"warningContainer":"ScheduleTimeOff_warningContainer__lhR15","modalContent":"ScheduleTimeOff_modalContent__q-Mkn","modalActions":"ScheduleTimeOff_modalActions__lfMWN"};